import { TRUCK_10, TRUCK_12, TRUCK_16, TRUCK_4, TRUCK_6, TRUCK_6_THREE_SINGLE } from "./dimensions";
import { Truck10Body, Truck12Body, Truck16Body, Truck4Body, Truck6Body, Truck6ThreeSingleBody } from "./TruckBody";
import {
  TRUCK_10_LAYOUT,
  TRUCK_10_WHEELS,
  TRUCK_12_LAYOUT,
  TRUCK_12_WHEELS,
  TRUCK_16_LAYOUT,
  TRUCK_16_WHEELS,
  TRUCK_4_LAYOUT,
  TRUCK_4_WHEELS,
  TRUCK_6_LAYOUT,
  TRUCK_6_THREE_SINGLE_LAYOUT,
  TRUCK_6_THREE_SINGLE_WHEELS,
  TRUCK_6_WHEELS
} from "./wheels";
const truck6Preset = {
  id: "truck-6-steer-dual",
  silhouette: "truck",
  renderModelKey: "truck",
  renderLayoutKey: "truck-6-wheel-v1",
  label: "2 axles, single steer and dual drive",
  layout: TRUCK_6_LAYOUT,
  wheels: TRUCK_6_WHEELS,
  camera: {
    position: [8.6, 4.1, 7.8],
    target: [0, 1.45, 0],
    minDistance: 6,
    maxDistance: 22,
    fov: 32
  },
  stage: { extent: TRUCK_6.length, contactHeight: 1.3 },
  skeleton: "axles",
  Body: Truck6Body
};
const truck10Preset = {
  id: "truck-10-steer-tandem",
  silhouette: "truck",
  renderModelKey: "truck",
  renderLayoutKey: "truck-10-wheel-v1",
  label: "3 axles, single steer and tandem dual drive",
  layout: TRUCK_10_LAYOUT,
  wheels: TRUCK_10_WHEELS,
  camera: {
    position: [9.8, 4.5, 8.8],
    target: [0, 1.5, 0],
    minDistance: 7,
    maxDistance: 26,
    fov: 32
  },
  stage: { extent: TRUCK_10.length, contactHeight: 1.3 },
  skeleton: "axles",
  Body: Truck10Body
};
const truck12Preset = {
  id: "truck-12-twin-steer-tandem",
  silhouette: "truck",
  renderModelKey: "truck",
  renderLayoutKey: "truck-12-wheel-v1",
  label: "4 axles, twin-steer and tandem dual drive",
  layout: TRUCK_12_LAYOUT,
  wheels: TRUCK_12_WHEELS,
  camera: {
    position: [10.8, 4.8, 9.7],
    target: [0, 1.55, 0],
    minDistance: 7.5,
    maxDistance: 29,
    fov: 32
  },
  stage: { extent: TRUCK_12.length, contactHeight: 1.3 },
  skeleton: "axles",
  Body: Truck12Body
};
const truck16Preset = {
  id: "truck-16-twin-steer",
  silhouette: "truck",
  renderModelKey: "truck",
  renderLayoutKey: "truck-16-wheel-v1",
  label: "5 axles, twin-steer and tri-axle dual bogie",
  layout: TRUCK_16_LAYOUT,
  wheels: TRUCK_16_WHEELS,
  camera: {
    position: [12, 5.2, 10.8],
    target: [0, 1.6, 0],
    minDistance: 8,
    maxDistance: 32,
    fov: 32
  },
  stage: { extent: TRUCK_16.length, contactHeight: 1.3 },
  skeleton: "axles",
  Body: Truck16Body
};
const truck6ThreeSinglePreset = {
  id: "truck-6-three-single",
  silhouette: "truck",
  renderModelKey: "truck",
  renderLayoutKey: "truck-6-three-single-v1",
  label: "3 axles, all single",
  layout: TRUCK_6_THREE_SINGLE_LAYOUT,
  wheels: TRUCK_6_THREE_SINGLE_WHEELS,
  camera: {
    position: [9.8, 4.5, 8.8],
    target: [0, 1.5, 0],
    minDistance: 7,
    maxDistance: 26,
    fov: 32
  },
  stage: { extent: TRUCK_6_THREE_SINGLE.length, contactHeight: 1.3 },
  skeleton: "axles",
  Body: Truck6ThreeSingleBody
};
const truck4Preset = {
  id: "truck-4-light-rigid",
  silhouette: "truck",
  renderModelKey: "truck",
  renderLayoutKey: "truck-4-wheel-v1",
  label: "2 axles, single fitment",
  layout: TRUCK_4_LAYOUT,
  wheels: TRUCK_4_WHEELS,
  camera: {
    position: [6.4, 3.2, 5.8],
    target: [0, 1.1, 0],
    minDistance: 4.5,
    maxDistance: 16,
    fov: 32
  },
  stage: { extent: TRUCK_4.length, contactHeight: 1.1 },
  skeleton: "axles",
  Body: Truck4Body
};
export {
  truck10Preset,
  truck12Preset,
  truck16Preset,
  truck4Preset,
  truck6Preset,
  truck6ThreeSinglePreset
};
